import {
  DateTimePicker,
  DateTimePickerProps,
} from '@mui/x-date-pickers/DateTimePicker';
import { FieldHookConfig, useField } from 'formik';

interface DateTimePickerExtraProps {
  name: string; // Use 'name' to align with useField expected field name
  required?: boolean;
  fullWidth?: boolean;
}

type FormDateTimePickerProps = DateTimePickerProps<Date> &
  DateTimePickerExtraProps;
/**
 * @typedef { object | DateTimeFieldProps } Props
 * @prop { FormikProps } formik
 * @prop { string } prop
 */

/** @type { React.FC<Props> } */
export const FormDateTimePicker: React.FC<FormDateTimePickerProps> = (
  props
) => {
  const [field, meta, helpers] = useField(
    props as FieldHookConfig<Date | null>
  );
  const { onChange } = props;
  const { setValue } = helpers;

  // onChange={(value) => formik.setFieldValue(prop, value, true)}
  return (
    <DateTimePicker
      slotProps={
        {
          textField: {
            error: !!(meta.touched && meta.error),
            helperText: meta.touched && meta.error,
            fullWidth: props.fullWidth,
            required: props.required,
          },
        } as any
      }
      {...field}
      {...props}
      onChange={(value, context) => {
        setValue(value);
        if (onChange) onChange(value, context);
      }}
    />
  );
};
